var DomCreator = {
  iframe(src, callback) {
    let iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.scrolling = 'no';
    iframe.style = 'max-height: 100000vw';
    iframe.addEventListener('load', () => {
      const height = iframe.contentWindow.document.querySelector('.global-container,center').offsetHeight;
      iframe.style = 'height:' + height +'px';
      callback();
    });
    return iframe;
  },
  symbol(string) {
    let div = document.createElement('div');
    div.classList.add('symbol');
    div.innerHTML = string;
    return div;
  },
  alert(text) {
    let div = document.createElement('div');
    div.classList.add('alert');
    div.innerHTML = text;
    return div;
  },
  removeAfter($element, countdown) {
    countdown = countdown || 0;
    setTimeout( () => {
      $element.remove();
    }, countdown * 1000);
  },
}

export default DomCreator;



// WEBPACK FOOTER //
// ./scripts/util/DomCreator.js